module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ui huge menu"
  }, [_c('a', {
    staticClass: "item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.triggerMenu($event)
      }
    }
  }, [_c('i', {
    staticClass: "content icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "right menu"
  }), _vm._v(" "), _c('a', {
    staticClass: "red item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addBoat($event)
      }
    }
  }, [_c('i', {
    staticClass: "plus icon"
  }), _vm._v(" Add Boat")])]), _vm._v(" "), _c('div', {
    staticClass: "ui container"
  }, [_c('h3', {
    staticClass: "ui header"
  }, [_vm._v("\n      Boats\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "ui loader",
    class: {
      'active': _vm.fetching
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "ui table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.boats), function(boat) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(boat.name))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "ui label"
    }, [_vm._v(_vm._s(boat.type))])]), _vm._v(" "), _c('td', [_vm._v("\n          €" + _vm._s(boat.price) + "/h\n        ")]), _vm._v(" "), _c('td', [_vm._v("\n          " + _vm._s(boat.capacity.max) + " Pax\n        ")]), _vm._v(" "), _c('td', {
      staticClass: "collapsing"
    }, [_c('div', {
      staticClass: "ui tiny buttons"
    }, [_c('div', {
      staticClass: "ui button",
      on: {
        "click": function($event) {
          _vm.editBoat(boat)
        }
      }
    }, [_c('i', {
      staticClass: "edit icon"
    }), _vm._v(" Edit Boat")]), _vm._v(" "), _c('div', {
      staticClass: "ui floating dropdown blue icon button",
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [_c('i', {
      staticClass: "dropdown icon"
    }), _vm._v(" "), _c('div', {
      staticClass: "menu"
    }, [_c('div', {
      staticClass: "item",
      on: {
        "click": function($event) {
          _vm.editBoat(boat)
        }
      }
    }, [_c('i', {
      staticClass: "edit icon"
    }), _vm._v(" Edit Boat")]), _vm._v(" "), _c('div', {
      staticClass: "item",
      on: {
        "click": function($event) {
          _vm.triggerDeleteBoat(boat)
        }
      }
    }, [_c('i', {
      staticClass: "trash icon"
    }), _vm._v(" Delete Boat")])])])])])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "ui small basic delete modal"
  }, [_c('div', {
    staticClass: "header",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n      Are you sure?\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n      Delete boat "), (_vm.boatForDelete) ? _c('strong', [_vm._v(_vm._s(_vm.boatForDelete.name))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "actions",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "ui green ok inverted button",
    on: {
      "click": function($event) {
        _vm.deleteBoat(_vm.boatForDelete)
      }
    }
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v("\n        Yes\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "ui small modal",
    attrs: {
      "id": "boatModal"
    }
  }, [_c('i', {
    staticClass: "close icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [(_vm.boat._id) ? _c('span', [_vm._v("Edit Boat")]) : _c('span', [_vm._v("Add Boat")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('form', {
    staticClass: "ui form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.boat.type),
      expression: "boat.type"
    }],
    staticClass: "ui selection dropdown",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.boat.type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "insel"
    }
  }, [_vm._v("Insel")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "sofa"
    }
  }, [_vm._v("Sofa Boat")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "paper"
    }
  }, [_vm._v("Paper Boat")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "oktagon"
    }
  }, [_vm._v("Oktagon")])])]), _vm._v(" "), _c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.boat.name),
      expression: "boat.name"
    }],
    staticClass: "ui input",
    domProps: {
      "value": (_vm.boat.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.boat.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ui two fields"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("People: Min")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.boat.capacity.min),
      expression: "boat.capacity.min"
    }],
    staticClass: "ui input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.boat.capacity.min)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.boat.capacity.min = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("People: Max")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.boat.capacity.max),
      expression: "boat.capacity.max"
    }],
    staticClass: "ui input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.boat.capacity.max)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.boat.capacity.max = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("Price p/h (€)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.boat.price),
      expression: "boat.price"
    }],
    staticClass: "ui input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.boat.price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.boat.price = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("Hidden for public booking")]), _vm._v(" "), _c('div', {
    staticClass: "ui toggle checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.boat.hidden),
      expression: "boat.hidden"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.boat.hidden) ? _vm._i(_vm.boat.hidden, null) > -1 : (_vm.boat.hidden)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.boat.hidden,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.boat.hidden = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.boat.hidden = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.boat.hidden = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label')])]), _vm._v(" "), _c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("Description")]), _vm._v(" "), _c('vue-editor', {
    model: {
      value: (_vm.boat.description),
      callback: function($$v) {
        _vm.boat.description = $$v
      },
      expression: "boat.description"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "ui icon positive button",
    on: {
      "click": _vm.saveBoat
    }
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v(" Save Boat\n      ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("\n          Name\n        ")]), _vm._v(" "), _c('th', [_vm._v("\n          Type\n        ")]), _vm._v(" "), _c('th', [_vm._v("\n          Price\n        ")]), _vm._v(" "), _c('th', [_vm._v("\n          Capacity\n        ")]), _vm._v(" "), _c('th', {
    staticClass: "collapsing"
  }, [_vm._v("\n          Actions\n        ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui red basic cancel inverted button"
  }, [_c('i', {
    staticClass: "remove icon"
  }), _vm._v("\n        No\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui icon cancel button"
  }, [_c('i', {
    staticClass: "delete icon"
  }), _vm._v(" Close\n      ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25e1afea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/Boats.vue
// module id = 734
// module chunks = 1